/**
 * gets the full HTML Document via a DOMParser
 * @constructor
 * @param {string} html the source html (full html document)
 * @returns {string} the full html document
 */
export const getFullDoc = (html: string) => {
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(html, 'text/html');

  return htmlDoc;
};

/**
 * converts a style string to a React style object
 * @constructor
 * @param {string} styleStr the style string
 * @returns {Record<string, string>} React style object
 */
export const getStyleObj = (styleStr = '') => {
  const styleObj: Record<string, string> = {};
  const camelize = (s: string) => s.replace(/-./g, (x) => x[1].toUpperCase());

  styleStr.split(';').forEach((stylePair) => {
    const kvPair = stylePair.split(':');
    const key = camelize(kvPair[0].trim());
    const value = (kvPair[1] || '').trim();
    if (key && value) {
      styleObj[key] = value;
    }
  });

  return styleObj;
};

/**
 * gets the node attributes as an object that is spreadable on a React component
 * @constructor
 * @param {NamedNodeMap} attrs collection of Attr objects
 * @returns {Record<string, string>} object of attribute names & values suitable to be spread as props
 */
export const getAttrObj = (attrs: NamedNodeMap) => {
  const attrObj: Record<string, string | Record<string, string>> = {};

  for (let idx = 0; idx < attrs.length; idx++) {
    const attr = attrs.item(idx);
    if (attr?.name && attr?.value) {
      switch (attr.name) {
        case 'style':
          attrObj.style = getStyleObj(attr.value);
          break;
        case 'class':
          attrObj.className = attr.value;
          break;
        default:
          attrObj[attr.name] = attr.value;
      }
    }
  }
  return attrObj;
};
